import * as yup from 'yup'

export const recepService = yup.object().shape({
  tipoRecepcionador: yup.string().required('El tipo recepcionador es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  empresaId: yup.string().required('La empresa es obligatorio'),
  companiaId: yup.string().required('La compañía es obligatorio'),
})
